import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  combineLatest,
  distinctUntilChanged,
  map,
  Observable,
  takeUntil,
} from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { ExportData } from "src/app/shared/data/exportData";
import { AudienceType } from "src/app/shared/enum/chart/audiance";
import { TechnicalCardSearchMethodEnum } from "src/app/shared/enum/chart/technical-data";
import { DateFilter } from "src/app/shared/models/date-filte.interface";
import { InputAudience } from "src/app/shared/models/input-audience.interface";
import { RetentionRate } from "src/app/shared/models/statistics/retentionRate";
import { TechnicalCardSearchMethod } from "src/app/shared/models/statistics/technical-data";
import { JwtService } from "src/app/shared/services/jwt.service";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  invokeFranchiseGlobalStatistics,
  invokeLocationPartnerGlobalStatistics,
  invokeRetentionRateByWeeks,
  resultConsumersByAgeAndGenderForLP,
  resultGlobalStatisticsForLP,
  resultRetentionRateByWeeks,
  resultSummaryStatics,
  resultUniqueConsumers,
} from "src/app/store/statistics/statistics.actions";
import {
  loadingGlobalStaticsSelector,
  resultRetentionRateByWeeksSelectors,
  resultGlobalStatisticsSelector,
  loadingRetentionRateSelector,
} from "src/app/store/statistics/statistics.selectors";
import { environment } from "src/environments/environment";
import { RetentionRateData } from "src/app/shared/data/exportData";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { resultSindingMail } from "src/app/store/mailing/mailing.actions";
import { sendMailSelector } from "src/app/store/mailing/mailing.selectors";
import { ToastrService } from "ngx-toastr";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { RefreshButtonState } from "src/app/shared/enum/refreshButtonState";
import { UserFeatureDto } from "src/app/shared/models/features/user-feature-dto.interface";
import { allFeaturesSelector } from "src/app/store/features/features.selectors";
import { AudienceStatisticsDto } from "../../models/statistics/audienceStatisticsDto.interface";
import { FeatureName } from "../../enum/feature-name.enum";
import { RoleEnum } from "../../models/user/role.interface";
import {
  roleToUserTypeMap,
  UserTypeEnum,
} from "../../models/user/userType.interface";
import { ActivatedRoute } from "@angular/router";
import { UtilFunctions } from "src/app/utils/utilFunctions";
import { invokeUserInfo, resultUserInfo } from "src/app/store/user/user.actions";
import { UserDto } from "../../models/user/userDto.interface";
import { resultUserInfoSelector } from "src/app/store/user/user.selectors";
import { initialState } from "src/app/store/user/user.reducers";
import { invokeAllFeatures } from "src/app/store/features/features.actions";
import { Constants } from "../../data/constants";

@Component({
  selector: "app-location-partner-stats-premium",
  templateUrl: "./location-partner-stats-premium.component.html",
})
export class LocationPartnerStatsPremiumComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  @Output() retentionRate = new EventEmitter<RetentionRate | null>();
  @Output() search = new EventEmitter<TechnicalCardSearchMethod>();
  companyName: string;
  reach = {
    value: 0,
    title: "location.statistics.reach",
    icon: "assets/identity/uniqueViews.svg",
    unit: 0,
  };
  consumers = {
    value: 0,
    title: "location.statistics.consumers",
    icon: "assets/identity/consummers.svg",
    unit: 0,
  };
  impression = {
    value: 0,
    title: "location.statistics.impression",
    icon: "assets/identity/eye-icon.svg",
    unit: 0,
  };
  @Output() inputAudience = new EventEmitter<InputAudience>();

  form: FormGroup;
  premium: boolean;
  columnChart = {
    title: "Données démographiques",
    yaxisTitle: "Taux de rétention en (%)",
    xaxisTitle: "Semaines",
  };
  resultRetentionRate$: Observable<RetentionRate | null>;
  loadingGlobalStatics$: Observable<boolean | null>;
  loadingAllStats$: Observable<boolean | null>;
  userInfo$: Observable<UserDto | null>;
  userInfo: UserDto | null  = initialState.userInfo
  features$: Observable<UserFeatureDto[] | null>;
  retentionChart: ExportData[] = RetentionRateData;
  dateFilter: DateFilter = {
    startDate: null,
    endDate: null,
  };
  bookMeeting: string;
  title: string;

  resultSendStatics$: Observable<SuccessDto | null>;
  cachedAt: Date | null;
  retentionRateCachedAt: Date | null;
  fetchingCardsState: RefreshButtonState = RefreshButtonState.IDLE;
  fetchingRetentionRateState: RefreshButtonState = RefreshButtonState.IDLE;

  resultGlobalStatistics$: Observable<AudienceStatisticsDto | null>;
  resultGlobalStatistics: AudienceStatisticsDto = {
    cachedAt: new Date(),
    impressions: 0,
    retainedConsumers: 0,
    uniqueConsumers: 0,
    reach: 0
  };
  email: string;

  loadingRetentionRate$: Observable<boolean>;

  today = new Date();
  startDate = Constants.twoMonthsAgo;
  constructor(
    private store: Store<AppStateInterface>,
    private jwtService: JwtService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private toastr: ToastrService,
    private saveHistory: SaveUserHistoryService,
    private route: ActivatedRoute
  ) {
    super(store);
    this.resultRetentionRate$ = this.store
      .pipe(select(resultRetentionRateByWeeksSelectors))
      .pipe(takeUntil(this.ngDestroyed$));
    this.loadingGlobalStatics$ = this.store
      .pipe(select(loadingGlobalStaticsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.userInfo$ = this.store
      .pipe(select(resultUserInfoSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.features$ = this.store
      .pipe(select(allFeaturesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.resultSendStatics$ = this.store
      .pipe(select(sendMailSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.loadingRetentionRate$ = this.store
      .pipe(select(loadingRetentionRateSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.form = this.fb.group({
      date: [[this.startDate, this.today]],
    });
    this.loadingAllStats$ = combineLatest([
      this.loadingGlobalStatics$,
    ])
      .pipe(map((flags) => flags.some((f) => f)))
      .pipe(takeUntil(this.ngDestroyed$));

    this.email = this.jwtService.getEmail();
    this.resultGlobalStatistics$ = this.store
      .pipe(select(resultGlobalStatisticsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }
  ngAfterViewInit(): void {
    if (this.userType() === UserTypeEnum.FRANCHISE) {
      this.inputAudience.emit({
        name: this.companyName,
        type: AudienceType.FRANCHISE,
        title: "Audiences",
        titleSpline: "invoices.summary",
        titleColumnChart: "invoices.distributionAgeGender",
        email : this.email
      });
      this.search.emit({
        technicalCard: TechnicalCardSearchMethodEnum.FRANCHISE,
        value: this.companyName ?? "",
        locationPartner: null,
        finished: false,
      });
    } else if (this.userType() === UserTypeEnum.LOCATION) {
      this.inputAudience.emit({
        name: this.companyName,
        type: AudienceType.LOCATION,
        title: "Audiences",
        titleSpline: "invoices.summary",
        titleColumnChart: "invoices.distributionAgeGender",
        email : this.email
      });
      this.search.emit({
        technicalCard: TechnicalCardSearchMethodEnum.LOCATION,
        value: this.companyName ?? "",
        locationPartner: null,
        finished: false,
      });
    }
  }

  userType(): UserTypeEnum {
    const role: RoleEnum = this.jwtService.getRoleName(
      this.jwtService.getToken()
    );
    if (role === RoleEnum.ROLE_ADMIN) {
      return this.route.snapshot.paramMap.get("userType") as UserTypeEnum;
    }
    return roleToUserTypeMap[role] ?? null;
  }

  ngOnInit(): void {
    this.store.dispatch(resultUserInfo({userInfo : null}))
    this.store.dispatch(invokeUserInfo())
    this.userInfo$.subscribe((data)=>{
      if(data){
        this.userInfo = data
      }
    })
    this.resultSendStatics$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.store.dispatch(resultSindingMail({ successMessage: null }));
        this.toastr.success(
          this.translate.instant("response.success." + result.message),
          this.translate.instant("response.successTitle")
        );
      }
    });
    this.title = this.jwtService.getCompanyName();
    this.companyName = this.jwtService.getCompanyName();
    this.store.dispatch(
      resultGlobalStatisticsForLP({ resultGlobalStatisticsForLP: null })
    );
    this.store.dispatch(resultRetentionRateByWeeks({ retentionRate: null }));
    this.store.dispatch(resultUniqueConsumers({ uniqueConsommers: null }));
    this.bookMeeting = environment.links.bookMeetingLP;
    this.store.dispatch(invokeAllFeatures({email : this.email}))
    this.features$.subscribe((result) => {
      if (result) {
        const findPremiumFeature = result.find(
          (feature) => feature.name === FeatureName.PREMIUM
        );
        if (
          findPremiumFeature &&
          findPremiumFeature.endDate &&
          new Date(findPremiumFeature.endDate) > new Date()
        ) {
          this.premium = true;
          this.fetchRetentionRate(false);
          this.fetchCardsStatistics(false);
        } else {
          this.store.dispatch(
            resultSummaryStatics({
              summaryStatistic: null,
            })
          );
          this.store.dispatch(
            resultConsumersByAgeAndGenderForLP({
              genderAgeStatistics: null,
            })
          );
        }
      }
    });
    this.resultRetentionRate$.subscribe((result) => {
      if (result != null) {
        this.retentionRateCachedAt = result.cachedAt;
        this.retentionRate.emit(result);
        this.retentionChart = UtilFunctions.exportRetentionRate(
          result,
          this.translate
        );
      }
    });

    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.GET,
      UserHistoryServicesEnum.CAMPAIGN_LOCATIONS_STATISTICS
    );

    this.form.valueChanges.subscribe((changes) => {
      this.dateFilter = {
        startDate: changes.date[0],
        endDate: changes.date[1],
      };
      if (this.premium) {
        this.fetchRetentionRate(false);
      }
    });

    this.resultGlobalStatistics$.subscribe((result) => {
      if (result) {
        this.resultGlobalStatistics = result;
        this.cachedAt = result.cachedAt;
      }
    });
  }

  fetchCardsStatistics(refreshCache: boolean) {
    if (refreshCache) {
      this.fetchingCardsState = RefreshButtonState.LOADING;
    }
    const userTypeEnum = this.userType();
    if (userTypeEnum === UserTypeEnum.FRANCHISE) {
      this.store.dispatch(
        invokeFranchiseGlobalStatistics({
          email: this.email,
          refreshCache: refreshCache,
        })
      );
    }

    if (userTypeEnum === UserTypeEnum.LOCATION) {
      this.store.dispatch(
        invokeLocationPartnerGlobalStatistics({
          email: this.email,
          refreshCache: refreshCache,
        })
      );
    }
    if (refreshCache) {
      combineLatest([this.loadingGlobalStatics$])
        .pipe(
          map((flags) => flags.some((f) => f)),
          distinctUntilChanged()
        )
        .subscribe((isLoading) => {
          if (!isLoading) {
            this.fetchingCardsState = RefreshButtonState.SUCCESS;
            setTimeout(() => {
              this.fetchingCardsState = RefreshButtonState.IDLE;
            }, 2_500);
          } else {
            this.fetchingCardsState = RefreshButtonState.LOADING;
          }
        });
    }
  }

  fetchRetentionRate(refreshCache: boolean) {
    if (refreshCache) {
      this.fetchingRetentionRateState = RefreshButtonState.LOADING;
    }
    this.store.dispatch(
      invokeRetentionRateByWeeks({
        email: this.email,
        filter: this.dateFilter,
        refreshCache: refreshCache,
      })
    );
    if (refreshCache) {
      this.resultRetentionRate$.subscribe((result) => {
        if (result) {
          this.fetchingRetentionRateState = RefreshButtonState.SUCCESS;
          setTimeout(
            () => (this.fetchingRetentionRateState = RefreshButtonState.IDLE),
            2500
          );
        } else {
          this.fetchingRetentionRateState = RefreshButtonState.IDLE;
        }
      });
    }
  }
}
